import React from "react";
import { GiftIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <section className="w-full bg-navy px-4 py-16 sm:py-20" data-id="element-82" data-mp="1cl6258j3xigj">
      <div className="mx-auto max-w-4xl" data-id="element-83" data-mp="1clpk2p8rc6uk">
        <div className="mx-auto flex w-fit items-center gap-2 rounded-full bg-alert px-4 py-2 font-display text-sm font-black uppercase text-white" data-id="element-84" data-mp="18jkwo88wk6gd">
          <GiftIcon className="h-4 w-4" aria-hidden data-id="element-85" data-mp="258k099yjkk28" /> 5 exclusive bonuses — free today
        </div>
        <h2 className="mt-5 text-center font-display text-[26px] font-black leading-tight text-white sm:text-4xl" data-id="element-86" data-mp="20c1ymiyid1u4">
          Five Additional Resources to Help You Apply What You Learn
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-mist" data-id="element-87" data-mp="1r9ankk9jo830">
          These bonuses complement the six volumes with practical exercises, review tools, and reusable planning templates.
        </p>

        <div className="-mx-4 mt-12 space-y-8 sm:mx-0" data-id="element-88" data-mp="ftm0lswaj927">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-white sm:rounded-3xl" data-id="element-89" data-mp="1eu6lr3t6gxqs">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full bg-white" loading="lazy" data-id="element-90" data-mp="1jrgdwr7ybnib" />
              <div className="px-5 pb-7 pt-2 sm:px-8" data-id="element-91" data-mp="15v2zxs2mm48l">
                <p className="font-display text-sm font-black uppercase tracking-wider text-alert" data-id="element-92" data-mp="1ar0fhw62f6kb">Bonus #{b.number}</p>
                <h3 className="mt-1 font-display text-[22px] font-black leading-tight text-ink sm:text-3xl" data-id="element-93" data-mp="w1m5cluo0l3v">{b.title}</h3>
                <p className="mt-3 inline-flex flex-wrap items-center gap-x-2 rounded-lg bg-ok/15 px-3 py-1.5 text-sm font-bold text-[#0d7a3a]" data-id="element-94" data-mp="10vysb5vcoekd">
                  <span data-id="element-95" data-mp="r3avib4dealn">Suggested value:</span>
                  <span className="line-through decoration-alert decoration-2" data-id="element-96" data-mp="r4cagqoibh8n">${b.value}</span>
                  <span className="text-ink" data-id="element-97" data-mp="d530w9ut3ldn">— FREE Today</span>
                </p>
                <p className="mt-4 text-[15px] leading-relaxed text-slate-700" data-id="element-98" data-mp="i2utz776tdjf">{b.text}</p>
                <p className="mt-4 rounded-xl bg-[#eef4ff] p-4 text-[14px] leading-relaxed text-slate-700" data-id="element-99" data-mp="2jtd7lxnmqx7e">
                  <span className="font-bold text-ink" data-id="element-100" data-mp="2f0abbhrgx9ni">Why I included it: </span>
                  {b.why}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-101" data-mp="262ge84lvqbza">
          <CTAButton label="I want all 5 bonuses free" data-id="element-102" data-mp="25z2g58k90oxn" />
        </div>
      </div>
    </section>;
}